import { IPropertyChange } from "../../interfaces/endpoints/IEntityChangeLog.types";

// The parsed `changes` JSON, or an empty object when the row has none or it does not parse.
export const parseChanges = (changes: string | null): Record<string, IPropertyChange> => {
  if (!changes) return {};
  try {
    const parsed: unknown = JSON.parse(changes);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, IPropertyChange>) : {};
  } catch {
    return {};
  }
};

// The parsed `previousState` JSON as column -> value, or an empty object.
export const parseState = (state: string | null): Record<string, unknown> => {
  if (!state) return {};
  try {
    const parsed: unknown = JSON.parse(state);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
};

// Pretty-prints stored JSON; falls back to the raw text if it does not parse.
export const prettyJson = (json: string): string => {
  try {
    return JSON.stringify(JSON.parse(json), null, 2);
  } catch {
    return json;
  }
};
